import { Button, Typography } from '@memoresa/ui-components';
import parse from 'html-react-parser';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import { useInitialRoute } from '../utils/hooks/useInitialRoute';
import { useSetLocale } from '../utils/hooks/useSetLocale';
import useWindowSize from '../utils/hooks/useWindowSize';

const NotFoundPage = props => {
  useSetLocale();
  const { t } = useTranslation();
  const { isSm } = useWindowSize();
  const { pushToInitialRoute } = useInitialRoute();
  const router = useRouter();
  return (
    <div
      className={
        'flex flex-col items-center w-full h-full space-y-6 md:space-y-6 mt-4'
      }
    >
      <img
        src={'/static/images/logos/mem/logotype_new.png'}
        className={'w-1/2 sm:w-4/12 md:w-3/12'}
        alt="memoresa"
      />
      <div className="flex flex-col items-center justify-center w-full px-2 pb-10 space-y-6 ul-adjustment">
        <div className="flex flex-col items-center justify-center space-y-4">
          <img
            src="/static/images/404/404.svg"
            alt="Maintenance work"
            style={{
              width: isSm ? 300 : 200,
              height: isSm ? 300 : 200,
            }}
          />
          <div
            className={
              'flex flex-col justify-center items-center text-center space-y-4'
            }
          >
            <Typography
              color={'primary'}
              className={'text-[33px] sm:text-4xl font-medium'}
            >
              {t('notFound.title')}
            </Typography>
            <Typography
              color={'primary'}
              className={
                'text-sm sm:text-lg font-light flex flex-col items-center justify-center text-center'
              }
            >
              {parse(t('notFound.description'))}
            </Typography>
          </div>
          <Button
            style={{
              textTransform: 'uppercase',
            }}
            onClick={() => pushToInitialRoute()}
          >
            {t('notFound.button')}
          </Button>
        </div>
      </div>
    </div>
  );
};
export default NotFoundPage;
